import { SemanticTokens } from '../../constants';
export var defaultElementMap = {
    heading: {
        '4xl': 'h1',
        '3xl': 'h1',
        '2xl': 'h2',
        xl: 'h2',
        l: 'h3',
        m: 'h4',
        s: 'h5',
        xs: 'h6',
        xxs: 'h6',
    },
    text: {
        '3xl': 'p',
        '2xl': 'p',
        xl: 'p',
        l: 'p',
        m: 'p',
        s: 'p',
    },
    link: {
        l: 'a',
        m: 'a',
        s: 'a',
    },
    label: {
        l: 'label',
        m: 'label',
        s: 'label',
        xs: 'label',
    },
};
export var colorMap = {
    primary: SemanticTokens.cssVars.TextPrimary,
    secondary: SemanticTokens.cssVars.TextSecondary,
    tertiary: SemanticTokens.cssVars.TextTertiary,
    'primary-inverse': SemanticTokens.cssVars.TextPrimaryInverse,
    'secondary-inverse': SemanticTokens.cssVars.TextSecondaryInverse,
    'tertiary-inverse': SemanticTokens.cssVars.TextTertiaryInverse,
    disabled: SemanticTokens.cssVars.TextDisabled,
    brand: SemanticTokens.cssVars.TextBrand,
    link: SemanticTokens.cssVars.TextLink,
    'link-hover': SemanticTokens.cssVars.TextLinkHover,
    'link-pressed': SemanticTokens.cssVars.TextLinkPressed,
    warning: SemanticTokens.cssVars.TextWarning,
    negative: SemanticTokens.cssVars.TextNegative,
    positive: SemanticTokens.cssVars.TextPositive,
    static: SemanticTokens.cssVars.TextStatic,
    'static-inverse': SemanticTokens.cssVars.TextStaticInverse,
};
